import { render } from "./IndividualPlanSelector.vue?vue&type=template&id=7065e2a0&scoped=true&ts=true"
import script from "./IndividualPlanSelector.vue?vue&type=script&lang=ts"
export * from "./IndividualPlanSelector.vue?vue&type=script&lang=ts"

import "./IndividualPlanSelector.vue?vue&type=style&index=0&id=7065e2a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7065e2a0"]])

export default __exports__